"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreComboChart_1 = require("./CoreComboChart");
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var withChart_1 = require("../_base/withChart");
var sanitizeStacking_1 = require("../_commons/sanitizeStacking");
//
// Internals
//
var comboChartDefinition = {
    chartName: "ComboChart",
    bucketPropsKeys: ["primaryMeasures", "secondaryMeasures", "viewBy", "filters", "sortBy"],
    propTransformation: function (props) {
        var _a, _b;
        var _c = props.primaryMeasures, primaryMeasures = _c === void 0 ? [] : _c, _d = props.secondaryMeasures, secondaryMeasures = _d === void 0 ? [] : _d;
        var isDualAxis = (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.dualAxis) !== null && _b !== void 0 ? _b : true;
        var computeRatioRule = !isDualAxis && primaryMeasures.length + secondaryMeasures.length > 1
            ? sdk_model_1.ComputeRatioRule.NEVER
            : sdk_model_1.ComputeRatioRule.SINGLE_MEASURE_ONLY;
        return tslib_1.__assign(tslib_1.__assign({}, props), { primaryMeasures: sdk_model_1.applyRatioRule(primaryMeasures, computeRatioRule), secondaryMeasures: sdk_model_1.applyRatioRule(secondaryMeasures, computeRatioRule) });
    },
    bucketsFactory: function (props) {
        var primaryMeasures = props.primaryMeasures, secondaryMeasures = props.secondaryMeasures, viewBy = props.viewBy;
        var categories = isArray_1.default(viewBy) ? [viewBy[0]] : [viewBy];
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], primaryMeasures)),
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.SECONDARY_MEASURES], secondaryMeasures)),
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.VIEW], categories)),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("ComboChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.defaultDimensions)
            .withExecConfig(execConfig);
    },
    propOverridesFactory: function (props) {
        return {
            config: getConfiguration(props),
        };
    },
};
function getConfiguration(props) {
    var _a, _b;
    var primaryMeasures = props.primaryMeasures, secondaryMeasures = props.secondaryMeasures, config = props.config;
    var isDualAxis = (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.dualAxis) !== null && _b !== void 0 ? _b : true;
    var measuresOnPrimaryAxis = isDualAxis ? primaryMeasures : tslib_1.__spreadArrays(primaryMeasures, secondaryMeasures);
    return sanitizeStacking_1.sanitizeConfig(measuresOnPrimaryAxis, config);
}
var WrappedComboChart = withChart_1.withChart(comboChartDefinition)(CoreComboChart_1.CoreComboChart);
/**
 * [ComboChart](https://sdk.gooddata.com/gooddata-ui/docs/combo_chart_component.html)
 *
 * Combo chart combines two types of visualizations, for example, a column chart and a line chart. A combo chart can
 * have one or two axes. If a combo chart has two axes, it is often referred to as a dual axis chart.
 *
 * By default, a combo chart is displayed as a combination of a column chart and a line chart, with the secondary axis
 * enabled (you can [disable it](https://sdk.gooddata.com/gooddata-ui/docs/combo_chart_component.html#disable-the-secondary-axis)).
 *
 * The chart types used to display primary and secondary measures can be customized in {@link IChartConfig}.
 *
 * @public
 */
exports.ComboChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.primaryMeasures, props.secondaryMeasures, props.viewBy, props.filters, props.sortBy], props.placeholdersResolutionContext), primaryMeasures = _a[0], secondaryMeasures = _a[1], viewBy = _a[2], filters = _a[3], sortBy = _a[4];
    return (react_1.default.createElement(WrappedComboChart, tslib_1.__assign({}, props, {
        primaryMeasures: primaryMeasures,
        secondaryMeasures: secondaryMeasures,
        viewBy: viewBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=ComboChart.js.map